import React, { ButtonHTMLAttributes } from "react";
import { StyleColor } from "lib/models";

import "./BubbleButton.scss";

export type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  color?: StyleColor;
};

export const BubbleButton: React.FC<Props> = (props) => {
  const { color = "primary" } = props;
  const [radiate, setRadiate] = React.useState<string>("");
  const classNameList = [
    props.className,
    "bubble-link",
    `bubble-link-${color}`,
  ];
  if (radiate) classNameList.push("radiate");

  const dazzle = () => {
    setRadiate("radiate");
    setTimeout(() => {
      setRadiate("");
    }, 300);
  };

  const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    dazzle();
    if (props.onClick) props.onClick(e);
  };

  const mergedProps = {
    ...props,
    onClick: onClick,
    className: classNameList.join(" "),
  };

  return <button {...mergedProps}>{props.children}</button>;
};
